import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { ManageSAR } from "./ManageSAR"
import { ManageSARCompanies } from "./ManageSARCompanies"

export const SectorAssociationTabs: React.FC = () => {
  const [subTab, setSubTab] = useState<"manageSAR" | "manageCompanies">("manageSAR")
  const { t } = useTranslation()

  const onChangeSubTab = (e: React.MouseEvent, newTab: "manageSAR" | "manageCompanies") => {
    e.preventDefault()
    setSubTab(newTab)
  }

  return (
    <div className="sector-association-tabs">
      <div className="card-header">
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li className="nav-item">
            <a
              href="#manage-sar"
              className={`nav-link ${subTab === "manageSAR" ? "active" : ""}`}
              data-toggle="pill"
              role="tab"
              onClick={(e) => onChangeSubTab(e, "manageSAR")}
            >
              {t("Manage SAR")}
            </a>
          </li>
          <li className="nav-item">
            <a
              href="#manage-sar-companies"
              className={`nav-link ${subTab === "manageCompanies" ? "active" : ""}`}
              data-toggle="pill"
              role="tab"
              onClick={(e) => onChangeSubTab(e, "manageCompanies")}
            >
              {t("Manage SAR's companies")}
            </a>
          </li>
        </ul>
      </div>

      <div className="tab-content">
        {subTab === "manageSAR" && <ManageSAR />}

        {subTab === "manageCompanies" && <ManageSARCompanies />}
      </div>
    </div>
  )
}
